export default __webpack_public_path__ + "static/media/warning--traffic-merges-left--g3.aa5ed805.png";